<template>
  <el-dialog
    :before-close="handleClose"
    :title="dialogTit"
    :visible.sync="dialogFormVisible"
    width="800px"
    top="20px"
    center
    calss="ac-dialog"
    :close-on-click-modal="false"
  >
  <div class="pf-warpper">
    <el-row class="table-form">
      <el-form
        :inline="true"
        label-width="60px"
        size="mini"
        class="form-inline"
      >
          <el-form-item>
            <div>总访问量：{{sumCount || 0}}</div>
          </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col>
        <el-table
          v-loading="loading"
          :data="list"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          border
          height="calc(100vh - 265px)"
          style="width: 100%"
          highlight-current-row>

          <el-table-column
            prop="btime"
            min-width="120"
            label="访问时间"
            align="center"
            fixed
          >
            <template slot-scope="scope">
              {{scope.row.btime}}
            </template>
          </el-table-column>

          <el-table-column
            prop="browernum"
            min-width="180"
            label="访问次数"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{scope.row.browernum}}
            </template>
          </el-table-column>

          <el-table-column label="操作" width="200" align="center" fixed="right" v-if="false">
            <template slot-scope="scope">
              <el-button
                size="mini"
                icon="el-icon-edit"
                type="primary"
                @click="handleAddOrEdit('edit', scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="table-pagination">
          <el-pagination
              :current-page="pageIndex"
              :page-sizes="[10, 20, 30, 40,50,100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
          />
        </div>
      </el-col>
    </el-row>
  </div>
  </el-dialog>
</template>
<script>
import Api from "@/api";

export default {
  name: "ChannelList",
  data() {
    return {
      list: [],
      imgLoadShow: false,
      loading: true, // el-table加载状态
      dialogTit: "明细查询",
      dialogFormVisible: false,
      appId: 0,
      // 页索引
      pageIndex: 1,
      // 页码
      pageSize: 31,
      total: 0, // 总条数
      sumCount: 0,
      selectRoles: [] // 存放数据库返回的角色数据
    };
  },
  watch: {
    total() {
      if (
        this.total === (this.pageIndex - 1) * this.pageSize &&
        this.total !== 0
      ) {
        this.pageIndex -= 1;
        this.getList(); // 获取列表数据
      }
    }
  },
  mounted() {
  },
  created() {},
  methods: {
    // 打开弹出框
    async openDialog(appId, appName) {
      this.dialogFormVisible = true;
      this.dialogTit = "【" + appName + "】点击明细";
      this.appId = appId;
      this.getList();
    },

    handleClose() {
      this.dialogFormVisible = false;
    },
    /**
     * 点击搜索按钮触发，并获取数据
     * @param {Null} 空
     * @return {Null} 空
     */
    onSubmit() {
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getList();
    },

    /**
     * 改变页码
     * @param {Number} val 当前页码
     * @return {Null} 空
     */
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    /**
     * 改变页索引
     * @param {Number} val 现在的页索引
     * @return {Null} 空
     */
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },

    async getList() {
      this.loading = true;
      this.imgLoadShow = false;
      try {
        const params = {
          pageNum: this.pageIndex,
          pageSize: this.pageSize,
          appId: this.appId
        };
        const res = await Api.queryStatList(params);
        this.imgLoadShow = true;
        if (res.code === 200 && res.data && res.data.list) {
          this.list = res.data.list;
          this.total = res.data.total;
          this.sumCount = res.data.sumCount;
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
input[type="file"] {
  display: none;
}
/deep/.el-table__cell{
  padding: 5px!important;
}
</style>
